import * as preact from 'preact';
import { ToolWrapper, Error, Loading, getBaseUrl } from './tools-common';
import { useFetch } from '../utils/async';

export function CalendarTool({ active }) {
	let dataUrl = `${getBaseUrl()}/wp-json/site-data/sidebar/events/`;
	let headers = { Accept: 'application/json' };
	let { data, error, isLoading } = useFetch(dataUrl, { headers });

	let menu_items = data?.calendar_tool?.menu_items || [];

	return (
		<ToolWrapper active={active} heading="Calendar">
			<a
				className="btn btn--xs btn--full tools-nav__viewall"
				href="https://wp.stolaf.edu/calendar/"
			>
				View Full Calendar →
			</a>

			{isLoading ? (
				<Loading />
			) : error ? (
				<Error error={error} />
			) : menu_items.length ? (
				<ul className="tools-nav__event-list">
					{menu_items.map(event => (
						<li className="tools-nav__event-item">
							<CalendarLink event={event} />
						</li>
					))}
				</ul>
			) : null}
		</ToolWrapper>
	);
}

function CalendarLink({ event }) {
	return (
		<a
			className="tools-nav__event-link tools-nav--focusable"
			href={event.permalink}
		>
			<span
				className="tools-nav__event-date"
				dangerouslySetInnerHTML={{ __html: event.full_date }}
			/>
			<h5 className="tools-nav__event-title">{event.title}</h5>
			{event.location ? (
				<CalendarLocation location={event.location} />
			) : null}
		</a>
	);
}

function CalendarLocation({ location }) {
	// this data is HTML-escaped by the CalendarTool PHP file
	return (
		<span
			className="tools-nav__event-venue"
			dangerouslySetInnerHTML={{ __html: location }}
		/>
	);
}
